import SEO from '@/components/base/SEO';
import HeroSection from './components/HeroSection';
import FeaturedComics from './components/FeaturedComics';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';
import { FAQ_DATA } from '@/mocks/comics';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '韩国漫画网',
      url: 'https://www.koreancomic.cn',
      description: '韩国漫画网支持韩漫在线阅读，提供免费的韩国漫画和无删减韩漫大全，资源持续更新。',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        email: 'contact@koreancomic.cn',
      },
    },
    {
      '@type': 'WebSite',
      name: '韩国漫画网',
      url: 'https://www.koreancomic.cn',
      description: '韩漫在线阅读平台 - 免费韩国漫画 无删减韩漫大全',
      inLanguage: 'zh-CN',
    },
    {
      '@type': 'WebPage',
      name: '韩国漫画网 - 首页',
      url: 'https://www.koreancomic.cn/',
      isPartOf: { '@id': 'https://www.koreancomic.cn/#website' },
      about: { '@id': 'https://www.koreancomic.cn/#organization' },
      primaryImageOfPage: {
        '@type': 'ImageObject',
        url: 'https://readdy.ai/api/search-image?query=A%20beautiful%20artistic%20illustration%20of%20a%20magical%20library%20filled%20with%20floating%20Korean%20manhwa%20pages&width=1600&height=900&seq=hero-bg-kcomic&orientation=landscape',
      },
    },
    {
      '@type': 'FAQPage',
      mainEntity: FAQ_DATA.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      })),
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEO
        title="韩国漫画网-韩漫在线阅读-免费的韩国漫画-无删减韩漫大全"
        description="韩国漫画网支持韩漫在线阅读，提供免费的韩国漫画和无删减韩漫大全，资源持续更新，让您尽情浏览各类韩漫内容。恋爱、奇幻、动作、悬疑等多种题材一网打尽，每日更新，免费畅读。"
        keywords="韩国漫画网,韩漫在线阅读,免费韩国漫画,无删减韩漫大全,韩漫推荐,韩国漫画"
        schema={homeSchema}
      />
      <main>
        <HeroSection />
        <FeaturedComics />
        <CategorySection />
        <LatestUpdates />
        <FAQSection />
      </main>
    </>
  );
}